module.exports = __webpack_public_path__ + "img/reaction5.613c6beb.png";